// extracted by mini-css-extract-plugin
export default {"container":"S+Tik","mobileTicketsContainer":"wtWRE"};